import type { Message } from '../../types';

export const getMessageKey = (message: Partial<Message>, index: number): string => {
  if (typeof message.id === 'string' && message.id.trim().length > 0) {
    return message.id;
  }

  const createdAt =
    message.createdAt instanceof Date
      ? message.createdAt.getTime()
      : typeof message.createdAt === 'string' || typeof message.createdAt === 'number'
        ? new Date(message.createdAt).getTime()
        : 'no-date';

  const performer = message.performedByUserId ?? 'owner';
  return `temp:${message.senderId ?? 'unknown'}:${performer}:${createdAt}:${index}`;
};

